import styled from 'src/style';
import colors from 'src/style/colors';
import fonts from 'src/style/fonts';
import { mediaQueries } from 'src/style/breakpoints';
import { Button } from 'src/components/Button';
import 'react-phone-number-input/style.css';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  marginTop: 100,
  [mediaQueries.phoneOnly]: {
    width: '100%',
    marginTop: 50,
  },
});

/* FORM */

export const SingleInputWrapper = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const MultipleInputWrapper = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  '& > div': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  '& > div:not(:last-child)': { marginRight: 30 },
  [mediaQueries.phoneOnly]: {
    '& > div:not(:last-child)': { marginRight: 0 },
    flexDirection: 'column',
  },
});

export const SimpleInput = styled.input(
  {
    ...fonts.HKCompakt.medium,
    backgroundColor: colors.white,
    borderRadius: 5,
    height: 42,
    outline: 'none',
    color: colors.purpleDark,
    ':focus': {
      border: `1px solid ${colors.purple}`,
    },
  },
  ({ errorStyle }) => ({
    border: errorStyle === true ? `1px solid red` : `1px solid ${colors.midGrey}`,
  })
);

export const SubmitButton = styled(Button)(
  {
    marginTop: 50,
    display: 'block',
    color: colors.white,
    minWidth: 133,
    minHeight: 62,
  },
  ({ isFullWidth }) => ({
    [mediaQueries.phoneOnly]: {
      width: isFullWidth ? '100%' : 145,
    },
  }),
  ({ disabledStyle }) => ({
    backgroundColor: disabledStyle ? colors.midGrey : colors.purple,
    '&:before': {
      backgroundColor: disabledStyle ? '' : 'rgba(255,255,255, 0.1)',
    },
    '&:hover': {
      color: disabledStyle ? '' : colors.white,
    },
  })
);
